import { render } from "./CourseMemberSubpage.vue?vue&type=template&id=73483fab&scoped=true"
import script from "./CourseMemberSubpage.vue?vue&type=script&lang=js"
export * from "./CourseMemberSubpage.vue?vue&type=script&lang=js"

import "./CourseMemberSubpage.vue?vue&type=style&index=0&id=73483fab&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73483fab"]])

export default __exports__